import type { SearchFilterApi } from '@ingenico/api-sdk-configuration-private';
import type {
  SearchDeploymentAutomatorsV2MutationRequestApi,
  SearchDeploymentAutomatorsV2MutationResponseApi,
} from '@ingenico/api-sdk-device-management-private-v2';
import type { SearchFilter } from '@ingenico/react-ui';
import type { AutomatorsSet } from '../model/configProfileV2.model';

export function buildDeploymentAutomatorsBody(configurationId: string): SearchDeploymentAutomatorsV2MutationRequestApi {
  return {
    filters: [
      {
        filterType: 'array',
        name: 'deploymentAutomator.configurationReference.id',
        operator: 'in',
        value: JSON.stringify([configurationId]),
      },
    ],
    sort: {},
  };
}

export function mapAutomatorsIds(response: SearchDeploymentAutomatorsV2MutationResponseApi): AutomatorsSet[] {
  return response.data.map((automator) => ({
    automatorId: automator.id,
    dynamicGroupId: automator.dynamicGroupReference.id,
  }));
}

export function buildDynamicGroupsFilters(data: AutomatorsSet[], filters: SearchFilter[]): SearchFilterApi[] {
  return [
    {
      filterType: 'array',
      name: 'dynamicGroup.id',
      operator: 'in',
      value: JSON.stringify(data.map((automator) => automator.dynamicGroupId)),
    },
    ...filters,
  ];
}
